import { searchArticlesByKnowledgeBaseId } from 'core_main/api/articles';
import { fetchKnowledgeBase } from 'core_main/api/knowledge_bases';
import { getStore, updateStore } from 'core_main/store';
import { PublicCallback } from 'globals/types';
import {
  createArticleCallbackResponse,
  createArticlesCallbackResponse,
} from '../get_articles/helpers';
import { SearchArticlesParameters } from './types';

export const runSearch = (searchParams, cb) => {
  return searchArticlesByKnowledgeBaseId(searchParams)
    .then((res) => {
      const articles = res.data.map((article) => {
        return createArticleCallbackResponse(article);
      });

      const callbackResponse = createArticlesCallbackResponse(articles);

      if (typeof cb === 'function') {
        cb(callbackResponse);
      }
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      console.error('Failed to search articles', error);
    });
};
export const searchArticles = (
  parameters: SearchArticlesParameters,
  cb?: PublicCallback,
) => {
  const store = getStore();
  const knowledgeBaseId =
    parameters?.knowledgeBaseId ||
    store.knowledgeBaseId ||
    store?.settings?.knowledgeBaseId;

  if (knowledgeBaseId) {
    return runSearch(
      {
        ...parameters,
        knowledgeBaseId,
      },
      cb,
    );
  }

  return fetchKnowledgeBase().then((res) => {
    const { id } = res.data;

    updateStore('knowledgeBaseId', id);

    runSearch(
      {
        ...parameters,
        knowledgeBaseId: id,
      },
      cb,
    );
  });
};
